module.exports = __webpack_public_path__ + "assets/img/user-s.f328d7c2.png";